import React, { FC } from 'react';
import FormBlock from 'src/components/FormBlock';
import { ClaimType } from 'src/types/claim';
import Detail from './Detail';
import FilesBlock from './FilesBlock';
import { ConstantsCodesObjectType, ConstantsCodeType } from 'src/types/constantsCodes';
import { ClaimChangelogType } from 'src/types/claimDetail';
import HistoryBlock from './HistoryBlock';
import ErrorLoggingBlock from './ErrorLoggingBlock';
import { sizes } from '../../themes/default';
import NewProductBlock from './NewProductBlock';
import ProductsTable from './ProductsTable';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface RenderComponentsPropsType {
    data: ClaimType | null;
    onChange: OnChangeType<EditKeysType>;
    onChangeProduct: OnChangeType<EditKeysType>;
    editData: ClaimType;
    editErrors: FormErrorsType;
    newClaim: boolean;
    disableEdit: boolean;
    permissionEditAll: boolean;
    isAttributeEditDisabled: (attributeKey: string) => boolean;
    allowedStatuses: ConstantsCodeType[];
    claimStatusCodes: ConstantsCodeType[];
    claimStatusCodesObject: ConstantsCodesObjectType;
    claimReasonCodes: ConstantsCodeType[];
    claimReasonCodesObject: ConstantsCodesObjectType;
    claimsResolverCodes: ConstantsCodeType[];
    claimsResolverCodesObject: ConstantsCodesObjectType;
    activeTab: string;
    changelog: ClaimChangelogType | null;
    skladonUser?: number;
    currencyCodes: ConstantsCodeType[];
    formRef: React.RefObject<HTMLFormElement>;
    productsFormRef: React.RefObject<HTMLFormElement>;
    canEditProducts: boolean;
    lineStateCodesObject: ConstantsCodesObjectType;
    boolNumberCodesObject: ConstantsCodesObjectType;
    canEditErrorLog: boolean;
    errorLogFormRef: React.RefObject<HTMLFormElement>;
}

const RenderComponents: FC<RenderComponentsPropsType> = (props) => {
    const renderDetail = () => (
        <>
            <form ref={props.formRef}>
                <Detail
                    data={props.data}
                    onChange={props.onChange}
                    editData={props.editData}
                    editErrors={props.editErrors}
                    newClaim={props.newClaim}
                    disableEdit={props.disableEdit}
                    permissionEditAll={props.permissionEditAll}
                    isAttributeEditDisabled={props.isAttributeEditDisabled}
                    allowedStatuses={props.allowedStatuses}
                    claimStatusCodes={props.claimStatusCodes}
                    claimReasonCodes={props.claimReasonCodes}
                    claimsResolverCodes={props.claimsResolverCodes}
                    skladonUser={props.skladonUser}
                    currencyCodes={props.currencyCodes}
                />
            </form>
            <FilesBlock
                onChange={props.onChange}
                editData={props.editData}
                editErrors={props.editErrors}
                isAttributeEditDisabled={props.isAttributeEditDisabled}
                skladonUser={props.skladonUser}
            />

                <FormBlock sx={{ marginTop: sizes.blocks_top_MG }}>
                    <NewProductBlock
                        data={props.editData.PRODUCTS || []}
                        onChange={(value: any) => props.onChange('PRODUCTS', value, false)}
                        disableEdit={props.disableEdit}
                        editErrors={props.editErrors}
                        canEditProducts={props.canEditProducts}
                        skladonUser={props.skladonUser}
                    />
                </FormBlock>
            <form ref={props.productsFormRef}>
                <ProductsTable
                    data={props.editData.PRODUCTS || []}
                    newClaim={props.newClaim}
                    onChange={(value: any, error: boolean, errorKey?: string) => {
                        props.onChangeProduct('PRODUCTS', value, error, errorKey);
                    }}
                    disableEdit={props.disableEdit}
                    editErrors={props.editErrors}
                    skladonUser={props.skladonUser}
                    canEditProducts={props.canEditProducts}
                />
            </form>
        </>
    );

    const renderErrorLogging = () => (
        <form ref={props.errorLogFormRef}>
            <ErrorLoggingBlock
                onChange={props.onChange}
                editData={props.editData}
                editErrors={props.editErrors}
                canEditErrorLog={props.canEditErrorLog}
            />
        </form>
    );

    const renderHistory = () => (
        <HistoryBlock
            changelog={props.changelog}
            claimStatusCodesObject={props.claimStatusCodesObject}
            claimReasonCodesObject={props.claimReasonCodesObject}
            claimsResolverCodesObject={props.claimsResolverCodesObject}
            lineStateCodesObject={props.lineStateCodesObject}
            skladonUser={props.skladonUser}
            boolNumberCodesObject={props.boolNumberCodesObject}
        />
    );

    switch (props.activeTab) {
        case 'detail':
            return renderDetail();

        case 'errorLogging':
            return renderErrorLogging();

        case 'history':
        default:
            return renderHistory();
    }
};

export default RenderComponents;
